import { createAsyncThunk } from "@reduxjs/toolkit";
import { $api } from "../../../../libs/axios";
import { objectsKiiAPI } from "libs/apiClient/ObjectsKii";

export const getDocuments = createAsyncThunk(
	"viewDocumentsSlice/getDocuments",
	async (objId: number, { rejectWithValue, getState }) => {
		try {
			const { stepFive }: any = getState();
			return await objectsKiiAPI
				.docReviewCreate(objId, {
					kiiAddrName: "string",
					kiiDocSuffix: "string",
					kiiObjName: stepFive.search,
					prevPageKiiObjId: "string",
				})
				.then((data) => {
					data.data = data.data.sort((a: any, b: any) => a.addressId - b.addressId);

					const docs: any[] = [];
					data.data.forEach((row: any) => {
						if (row.addressId === 0) {
							docs.push(row);
							return;
						}

						const finded = docs.find((item: any) => item.kiiObjId === row.kiiObjId);

						if (finded && row.addressId !== 0) {
							if (!finded.subRows) finded.subRows = [];
							finded.subRows.push(row);
						}
					});

					return docs;
				});
			// return $api
			// 	.post(`/objects_kii/${objId}/doc_review`, )
			// 	.then((data) => {
			// 	});
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const downloadDoc = createAsyncThunk(
	"viewDocumentsSlice/downloadDoc",
	async (body: { docId: number | null; fileName?: string }, { rejectWithValue }) => {
		try {
			return await objectsKiiAPI.docsDetail(body.docId!, "docx", { format: "blob" }).then((response) => {
				const href = URL.createObjectURL(response.data);

				// create "a" HTML element with href to file & click
				const link = document.createElement("a");
				link.href = href;
				link.setAttribute("download", `${body.fileName ? body.fileName : "file"}`); //or any other extension
				document.body.appendChild(link);
				link.click();

				// clean up "a" element & remove ObjectURL
				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			});
			// return $api({
			// 	url: `/objects_kii/docs/${body.docId}/docx`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then((response) => {
			// 	// create file link in browser's memory
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const uploadDoc = createAsyncThunk(
	"viewDocumentsSlice/uploadDoc",
	async (
		body: {
			docId: number;
			file: any;
			userCred: { lastName: string; firstName: string; middleName: string };
			orgId: number;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			// const params = new FormData();
			// params.append("file", body.file);

			// let url = `/objects_kii/docs/${body.docId}/upload`;
			const data = await objectsKiiAPI.docsUploadCreate(body.docId, { ApprovedDoc: body.file }).then((r) => r.data);
			// const data = (await $api.post(url, params)).data;
			dispatch(getDocuments(body.orgId));
			return data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const deleteDoc = createAsyncThunk(
	"viewDocumentsSlice/deleteDoc",
	async (docId: number | null, { rejectWithValue, dispatch }) => {
		try {
			return $api.delete(`/objects_kii/docs/${docId}/deleteGroup`).then((r) => {
				dispatch(getDocuments(r.data[0].orgId));
				return r.data;
			});
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
